<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex" :areaShow="areaShow" :loginShow="loginShow"  :get-party-id="getPartyId" :reload-page="reloadPage"></headers>


          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)" style="color:#888888" @click="urlTo('applyIndex')"> 个人办事</a> / <a href="javascript:void(0)" @click="urlTo('marriageAppointment',{opType:data.opType,title:title,swFlag: data.swFlag})"  style="color:#888888">{{title}}</a> / <span>{{title}}填报</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice" >
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{title}}填报</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
            <el-form  :rules="rules" :model="data" label-width="170px" ref="ruleForm" class="demo-ruleForm">
              <div style="padding-top: 40px;padding-bottom: 40px;text-align: center;color: #909399">
                <span style="padding-right: 50px">
                登记处名称:{{data.deptName}}
              </span>
                <span style="padding-right: 50px">
                预约日期:{{data.bookDate}}
              </span>
                <span>
                预约时间段:{{data.startTime}}--{{data.endTime}}
              </span>
              </div>
              <div>
                <h2 class="information_tit">男方信息</h2>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="男方姓名" prop="nameMan">
                      <el-input v-model="data.nameMan" placeholder="请输入" maxlength="50" style="width:250px"></el-input>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col v-if="data.swFlag == 1" style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="男方国籍：" prop="nationMan">
                      <el-select
                        v-model="data.nationMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in gj"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="男方身份类别：" prop="idTypeMan">
                      <el-select
                        v-model="data.idTypeMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in sflb"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="男方证件类型：" prop="certTypeMan">
                      <el-select
                        v-model="data.certTypeMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in zjlx"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="男方身份证件号：" prop="certNumMan">
                      <el-input v-model="data.certNumMan"   maxlength="18"   placeholder="请输入开户身份证号"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="男方出生日期：" prop="birthMan">
                      <el-date-picker type="date" placeholder="选择出生日期" v-model="data.birthMan" value-format="yyyy-MM-dd" style="width: 250px;"></el-date-picker>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  v-if="data.opType=='IA'||data.opType=='IB' ||data.opType=='ICB' " label="男方民族："  prop="certTypeMan">
                      <el-select
                        v-model="data.folkMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in mz"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item  v-else label="男方民族："  >
                      <el-select
                        v-model="data.folkMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in mz"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>

                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  v-if="data.opType=='IA'||data.opType=='IB' ||data.opType=='IBSQ' " label="男方职业：" prop="jobMan" >
                      <el-select
                        v-model="data.jobMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in zy"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item  v-else label="男方职业："  >
                      <el-select
                        v-model="data.jobMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in zy"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item    v-if="data.opType=='IA'||data.opType=='IB' ||data.opType=='IBSQ' "label="男方文化程度：" prop="degreeMan" >
                      <el-select
                        v-model="data.degreeMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in whcd"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item  v-else label="男方文化程度："  >
                      <el-select
                        v-model="data.degreeMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in whcd"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="男方常住户口：" prop="checkCity">
                      <el-cascader v-model="checkCity" :props="props" :show-all-levels="false"   @change="onSelectedRegion" placeholder="请选择常住户口" clearable style="width: 250px;"></el-cascader>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="联系方式（男）：" prop="mobile">
                      <el-input v-model="data.mobile" maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </div>
                  </el-col>
                  <el-col  v-if="data.opType=='IA'" style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item   label="男方婚姻状况：" prop="marryStatusMan" >
                      <el-select
                        v-model="data.marryStatusMan"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in hyzk"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>

                  <el-col style="padding-left: 13%" :span="18"><div class="grid-content bg-purple-light">
                    <el-form-item label="男方常住户口所在地：" prop="regDetailMan">
                      <el-input v-model="data.regDetailMan"  maxlength="30" placeholder="请输入男方常住户口所在地"  style="width: 700px;"></el-input>
                    </el-form-item>
                  </div>
                  </el-col>
                </el-row>
              </div>
            <div>
              <h2 class="information_tit">女方信息</h2>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="女方姓名" prop="nameWoman">
                    <el-input v-model="data.nameWoman" placeholder="请输入" maxlength="50" style="width:250px"></el-input>
                  </el-form-item>
                </div>
                </el-col>
                <el-col v-if="data.swFlag == 1" style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  label="女方国籍：" prop="nationWoman">
                    <el-select
                      v-model="data.nationWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in gj"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="女方身份类别：" prop="idTypeWoman">
                    <el-select
                      v-model="data.idTypeWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in sflb"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                </el-col>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  label="女方证件类型：" prop="certTypeWoman">
                    <el-select
                      v-model="data.certTypeWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in zjlx"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="女方身份证件号：" prop="certNumWoman">
                    <el-input v-model="data.certNumWoman"   maxlength="18"   placeholder="请输入开户身份证号"  style="width: 250px;"></el-input>
                  </el-form-item>
                </div>
                </el-col>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  label="女方出生日期：" prop="birthWoman">
                    <el-date-picker type="date" placeholder="选择出生日期" v-model="data.birthWoman" value-format="yyyy-MM-dd" style="width: 250px;"></el-date-picker>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  v-if="data.opType=='IA'||data.opType=='IB' ||data.opType=='ICB' " label="女方民族："  prop="folkWoman">
                    <el-select
                      v-model="data.folkWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in mz"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item  v-else label="女方民族："  >
                    <el-select
                      v-model="data.folkWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in mz"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>

                </div>
                </el-col>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  v-if="data.opType=='IA'||data.opType=='IB' ||data.opType=='IBSQ' " label="女方职业：" prop="jobWoman" >
                    <el-select
                      v-model="data.jobWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in zy"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item  v-else label="女方职业："  >
                    <el-select
                      v-model="data.jobWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in zy"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item    v-if="data.opType=='IA'||data.opType=='IB' ||data.opType=='IBSQ' "label="女方文化程度：" prop="degreeWoman" >
                    <el-select
                      v-model="data.degreeWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in whcd"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item  v-else label="女方文化程度："  >
                    <el-select
                      v-model="data.degreeWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in whcd"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                </el-col>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  label="女方常住户口：" prop="checkCity2">
                    <el-cascader v-model="checkCity2" :props="props" :show-all-levels="false"   @change="onSelectedRegion2" placeholder="请选择常住户口" clearable style="width: 250px;"></el-cascader>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="联系方式（女）：" prop="tel">
                    <el-input v-model="data.tel" maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                  </el-form-item>
                </div>
                </el-col>
                <el-col v-if="data.opType=='IA'" style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item   label="女方婚姻状况：" prop="marryStatusWoman" >
                    <el-select
                      v-model="data.marryStatusWoman"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in hyzk"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>

                <el-col style="padding-left: 13%" :span="18"><div class="grid-content bg-purple-light">
                  <el-form-item label="女方常住户口所在地：" prop="regDetailWoman">
                    <el-input v-model="data.regDetailWoman"  maxlength="30" placeholder="请输入女方常住户口所在地"  style="width: 700px;"></el-input>
                  </el-form-item>
                </div>
                </el-col>
              </el-row>
            </div>
              <div  v-if="data.opType!='IA'">
              <h2 class="information_tit">其它信息</h2>
              <el-row v-if="data.opType!='IA'">
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item   label="原登记日期" prop="oldOpDate">
                    <template >
                      <div class="block">
                        <el-date-picker
                          style="width: 250px"
                          value-format="yyyy-MM-dd"
                          v-model="data.oldOpDate"
                          type="date"
                          placeholder="选择日期">
                        </el-date-picker>
                      </div>
                    </template>
                  </el-form-item>
                </div>
                </el-col>
                <el-col  style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  label="原登记机关名称：" prop="oldDeptName">
                    <el-input v-model="data.oldDeptName" maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                  </el-form-item>
                </div></el-col>
              </el-row>
                <el-row >
                <el-col v-if="data.opType!='IA'" style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="原登记字号：" prop="oldCertNo">
                    <el-input  v-model="data.oldCertNo" maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                  </el-form-item>
                </div>
                </el-col>
                <el-col  v-if="data.opType=='IBSQ'||data.opType=='IB'" style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item   label="离婚原因：" prop="divorceReason" >
                    <el-select
                      v-model="data.divorceReason"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in lhyy"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div></el-col>
              </el-row>

            </div>
              <div  >
              <h2 class="information_tit">附件信息</h2>
              <el-row  v-for="(photo,index) in data.photoTypes"   :key="index">
                <!--  //婚姻登记并且身份类别为军人的必填，否则就不显示-->
                <div v-if="(data.idTypeMan=='7'|| data.idTypeWoman=='7')&& (data.opType=='IA')&&(photo.type=='jg_card'||photo.type=='jg_zm')">
                  <el-col style="padding-left: 13%" :span="18"><div class="grid-content bg-purple-light">
                    <el-form-item   :label="photo.title"  :prop="`photoTypes.${index}.attachIds`" :rules="[{ required: true, message: '请上传'+photo.title,trigger: 'change'}]" >
                      <imgUploaderOne :file-type="photo.twoTypeCode" :limit="1"  v-model="photo.attachIds"/>
                    </el-form-item>
                  </div>
                  </el-col>
                </div>
                <!--//按需提供证明-->
                <div v-else-if="(data.opType=='IA')&& (photo.type=='jg_pic'||photo.type=='jg_lh_pic'||photo.type=='jg_so_pic')">
                  <el-col style="padding-left: 13%" :span="18"><div class="grid-content bg-purple-light">
                    <el-form-item   :label="photo.title"  :prop="`photoTypes.${index}.attachIds`"  >
                      <imgUploaderOne :file-type="photo.twoTypeCode" :limit="1"  v-model="photo.attachIds"/>
                    </el-form-item>
                  </div>
                  </el-col>
                </div>
                <div v-else-if="(photo.type!='jg_card'&&photo.type!='jg_zm')">
                  <el-col style="padding-left: 13%" :span="18"><div class="grid-content bg-purple-light">
                    <el-form-item   :label="photo.title"  :prop="`photoTypes.${index}.attachIds`" :rules="[{ required: true, message: '请上传'+photo.title,trigger: 'change'}]" >
                      <imgUploaderOne :file-type="photo.twoTypeCode" :limit="1"  v-model="photo.attachIds"/>
                    </el-form-item>
                  </div>
                  </el-col>
                </div>

              </el-row>

            </div>
              <div>
                <el-row>
                  <el-col style="padding-left: 13%" :span="18"><div class="grid-content bg-purple-light">
                  <!--  <el-form-item  label="验证码：" prop="tel">-->
                    <el-form-item  label="验证码：" >
                      <el-input v-model="data.validCode" maxlength="11" placeholder="请输入"  style="width: 250px;"></el-input>
                      <img    :src="vImg" @click="getVerifyCode('gr')">
                    </el-form-item>
                  </div>
                  </el-col>

                </el-row>
              </div>
            <div style="text-align: center">
              <el-button :loading="loading" type="primary" @click="submit" style=" width: 250px;
                         margin-left: 100px;" :disabled="disableds">提   交</el-button>
            </div>

            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div style="line-height: 35px;">
      <el-dialog :close-on-click-modal ="false" :before-close="handleDialogClose" :visible.sync="showClause" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">业务办理须知</div>
        <div style="font-size: 14px;margin-left: 40px;margin-right: 35px;">
          1、办理青海省婚姻登记预约业务需要符合以下条件之一：<br/>
          1.1 双方或者一方常住户口在本省的内地居民之间的婚姻登记；<br/>
          1.2 常住户口在本省的内地居民同外国人、香港居民、澳门居民、台湾居民以及华侨的婚姻登记；<br/>
          1.3 部队驻地或者入伍前常住户口在本省的现役军人婚姻登记；<br/>
          2、预约人必须按照规定步骤，如实、准确填报当事人的信息，选定办理日期、时段，完成预约程序。<br/>
          3、预约人填报当事人信息有误或不实，视为预约不成功。<br/>
          4、预约成功当事人应当在预约日期、时段（可适当提前）到婚姻登记机关办理相关手续，婚姻登记机关将在当天所选时段内办理婚姻登记相关手续。<br/>

          <p v-if="data.swFlag == 1 || data.swFlag=='1'">
          <b>其他说明:</b > <br />
          一、所在国为《公约》缔约国的华侨办理结婚登记所需预审材料包括：     <br />
          （一）华侨本人的有效护照；<br />
          （二）居住国公证机构或者有权机关出具的本人无配偶以及与对方当事人没有直系血亲和三代以内旁系血亲关系的证明，或者中华人民共和国驻该国使（领）馆出具的本人无配偶以及与对方当事人没有直系血亲和三代以内旁系血亲关系的证明及中文译文；<br />
          （三）附加证明书及中文译文；<br />
          （四）核验材料及中文译文；<br />
          （五）国内方户口簿原件；<br />
          （六）国内方身份证原件；<br />
          （七）离异的需提供离婚证或法院出具的离婚调解书或已生效的离婚判决书;<br />
          （八）丧偶的需提供配偶居民死亡医学证明（推断）书;<br />
          （九）两寸红底免冠合照三张;<br />
          二、所在国为《公约》缔约国的外国人办理结婚登记所需预审材料包括：<br />
          （一）本人的有效护照原件或者其他有效的国际旅行证件原件；<br />
          （二）所在国公证机构或者有权机关出具的本人无配偶的证明原件，或者所在国驻华使（领）馆出具的本人无配偶证明原件及中文译文；<br />
          （三）附加证明书原件及中文译文；<br />
          （四）核验材料原件及中文译文；<br />
          （五）国内方户口簿原件；<br />
          （六）国内方身份证原件；<br />
          （七）离异的需提供离婚证或法院出具的离婚调解书或已生效的离婚判决书；<br />
          （八）丧偶的需提供配偶居民死亡医学证明（推断）书；<br />
          （九）两寸红底免冠合照三张。<br />
          附加证明书指文书出具国指定的主管机关为公文书签发的一个验证证书，具有《公约》要求的固定内容，具体包括文书出具国、签署人、签署人身份和印鉴名称 4 项文书相关信息，以及签发地、签发日期、签发人、附加证明书编号、签发机关印鉴和签名 6 项证明信息共 10 个要素。为便利公文书在国外使用，附加证明书一般使用包括英、法文及本国语言在内的两种或三种语言的范本。公文书加贴附加证明书后，可直接送往《公约》缔约国使用，无需办理传统领事认证。每份附加证明书都有一个公开注册的编号，用文方可利用文书出具国提供的核查渠道验证其真伪。<br />
          附加证明书与领事认证书功能等同，仅证明公文书上最后一个印鉴、签名属实，不对公文书内容本身的真实性和合法性负责。公文书内容真实性仍遵循“谁出具，谁负责”原则。<br />
          附加证明书特指为认证无配偶证明及无血亲关系证明的附加证明书。<br />
          核验材料指核验缔约国签发的附加证明书真伪的材料，核验 途径：<br />
          （一）应当事人申请、签发附加证明书的主管机关核实附加证明书的核验记录；<br />
          （二）登录缔约国核验网址，根据提示输入内容后生成的核验结果为真的页面。<br />
          </p>
        </div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>

    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import imgUploaderOne from "../../components/ImgUploaderOne";
  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers,imgUploaderOne
    },

    data() {
      let _self=this;
      return {
        clientType:'web',
        allowYd: 0, // 校验异地标识,0-区内,1-市内,2-省内,3-省外
        deptCode: '',
        disableds:false,
        areaShow:false,
        totalShow:false,
        loginShow:false,
        gotoIndex:false,
        showClause:true,
        loading:false,
        registryType: [
          {code:1,name:'test'},
        ],
        whcd: [
          {code:1,name:'test'},
        ],
        hyzk: [
          {code:1,name:'test'},
        ],
        zjlx: [
          {code:1,name:'test'},
        ],
        mz: [
          {code:1,name:'test'},
        ],
        gj: [
          {code:1,name:'test'},
        ],
        zy: [
          {code:1,name:'test'},
        ],
        sflb: [
          {code:1,name:'test'},
        ],
        lhyy: [
          {code:1,name:'test'},
        ],
        selectedRegion:[],
        data:{
          attachIds:'',
          deptId:'',
          sfys:'',
          deptName:'',
          nameWoman:'',
          jobManName:'',
          marryStatusManName:'',
          degreeManName:'',
          divorceReasonName:'',
          folkWomanName:'',
          idTypeManName:'',
          certTypeManName:'',
          folkManName:'',
          opType:'',
          bookDate:'',
          bookTimeId:'',
          startTime:'',
          endTime:'',
          nameMan:'',
          idTypeMan:'',
          idTypeWoman:'',
          idTypeWomanName:'',
          nationMan:'156',
          nationWoman:'156',
          certTypeMan:'',
          certTypeWoman:'',
          certTypeWomanName:'',
          certNumMan:'',
          certNumWoman:'',
          birthMan:'',
          birthWoman:'',
          folkMan:'',
          folkWoman:'',
          marryStatusMan:'',
          marryStatusWoman:'',
          marryStatusWomanName:'',
          oldOpDate:'',
          oldDeptName:'',
          oldCertNo:'',
          divorceReason:'',
          jobMan:'',
          jobWoman:'',
          jobWomanName:'',
          degreeMan:'',
          degreeWoman:'',
          degreeWomanName:'',
          regSjMan:'',
          regSjWoman:'',
          regDsMan:'',
          regDsWoman:'',
          regQxMan:'',
          regQxWoman:'',
          regJxMan:'',
          regJxWoman:'',
          regDetailMan:'',
          regDetailWoman:'',
          mobile:'',
          tel:'',
          swFlag: 0,
          edocList:'',
          codeId:'',
          validCode:'',
          ptslh:'',
          photoTypes:[],
        },
        ruleForm:{

        },
        rules:{
          nameMan:[{required:true ,message:'请输入男方姓名',tigger:'blur'}],
          idTypeMan:[{required:true ,message:'请选择男方身份类别',tigger:'blur'}],
          certTypeMan:[{required:true ,message:'请选择男方证件类型',tigger:'blur'}],
          birthMan:[{ type: 'string', required: true, message: '请选择男方出生日期', trigger: 'blur' }],
          nationMan:[{required:true ,message:'请选择男方国籍',tigger:'blur'}],
          certNumMan:[{required:true,validator:this.checkUidMan,tigger:'blur'}],
          folkMan:[{required:true ,message:'请输入男方民族',tigger:'blur'}],
          marryStatusMan:[{required:true ,message:'请选择男方婚姻状况',tigger:'blur'}],
          jobMan:[{required:true ,message:'请选择男方职业',tigger:'blur'}],
          degreeMan:[{required:true ,message:'请选择男方文化程度',tigger:'blur'}],
          regDetailMan:[{required:true ,message:'请选择男方常住户口所在地',tigger:'blur'}],
          checkCity:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          mobile:[{required:true,message:'请输入联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],

          nameWoman:[{required:true ,message:'请输入女方姓名',tigger:'blur'}],
          idTypeWoman:[{required:true ,message:'请选择女方身份类别',tigger:'blur'}],
          certTypeWoman:[{required:true ,message:'请选择女方证件类型',tigger:'blur'}],
          birthWoman:[{ type: 'string', required:true ,message:'请选择女方出生日期',tigger:'blur'}],
          nationWoman:[{required:true ,message:'请选择女方国籍',tigger:'blur'}],
          certNumWoman:[{required:true,validator:this.checkUidWoman,tigger:'blur'}],
          folkWoman:[{required:true ,message:'请输入女方民族',tigger:'blur'}],
          marryStatusWoman:[{required:true ,message:'请选择女方婚姻状况',tigger:'blur'}],
          jobWoman:[{required:true ,message:'请选择女方职业',tigger:'blur'}],
          degreeWoman:[{required:true ,message:'请选择女方文化程度',tigger:'blur'}],
          regDetailWoman:[{required:true ,message:'请选择女方常住户口所在地',tigger:'blur'}],
          checkCity2:[{required:true,validator:this.checkDepartId2,tigger:'blur'}],
          tel:[{required:true,message:'请输入联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],
          oldOpDate:[{required:true ,message:'请选择原登记日期',tigger:'blur'}],
          oldDeptName:[{required:true ,message:'请输入原登记机关名称',tigger:'blur'}],
          oldCertNo:[{required:true ,message:'请输入原登记字号',tigger:'blur'}],
          divorceReason:[{required:true ,message:'请选择离婚原因',tigger:'blur'}],
          attachIds:[{required:true ,message:'请选择上传附件',tigger:'blur'}],
        },
        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=0;
            }else {
            }
            const options={areaCode:node.value}
            _self.$https.post("api/marriage/getAreaInfo.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.areaName, value: e.areaCode, level: e.parentCode}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        photoTypes:[],
        vImg:'',
        checkCity:'',
        checkCity2:'',
      }
    } ,
    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },
      'data.idTypeMan'(n,o){
        this.getAttachEnumerationType();
      },
      'data.idTypeWoman'(newVal, oldVal){
        this.getAttachEnumerationType();
      }
    },
    created(){
      var userId=this.$cookies.get('userId')
      if (userId==null){
        this.showClause=false;
      }
      this.title=this.$route.query.title;
      this.data.opType=this.$route.query.opType;
      if(this.$route.query.swFlag){
       this.data.swFlag=this.$route.query.swFlag;
      }
      this.data.deptName=this.$route.query.deptName;
      this.data.deptId=this.$route.query.deptId;
      this.data.bookTimeId=this.$route.query.timeId;
      this.data.bookDate=this.$route.query.bookDate ;
      this.data.startTime=this.$route.query.startTime;
      this.data.endTime=this.$route.query.endTime;
      this.deptCode=this.$route.query.deptCode;
      if(this.$route.query.allowYd != null) {
        this.allowYd = this.$route.query.allowYd;
      }
    },
    mounted() {
      // 获取applyId;
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
        return;
      }
      this.dictSelect();
      this.getAttachEnumerationType();
      this.getVerifyCode();
    },
    methods: {
      dictSelect(){
        this.$https.post("api/marriage/getMarriageDict.do", {type: this.data.swFlag},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.$util.readData(response.data.data,this)
          }
        })
      },
      reloadPage(){
        this.reload();
      },
      getPartyId(a){

      },
      checkUidMan(rule,value,callback){
        let certType = this.data.certTypeMan;
        // 内地居民身份证才校验
        if(certType == 1) {
          callback(this.$util.func.uid.check(value))
          this.data.birthMan = this.$util.func.uid.getBirth(value);
        }
        return callback();
      },
      checkUidWoman(rule,value,callback){
        let certType = this.data.certTypeWoman;
        // 内地居民身份证才校验
        if(certType == 1) {
          callback(this.$util.func.uid.check(value))
          this.data.birthWoman = this.$util.func.uid.getBirth(value);
        }
        return callback();
      },
      getAttachEnumerationType(){
        if(this.data.swFlag == 0) {
          this.$https.post("api/marriage/getAttachEnumerationType.do", {opType:this.data.opType},response=>{
            if (response.status === 200 && response.data.code===200) {
              this.data.photoTypes=response.data.data;
            }
          })
        } else {
          if (this.data.idTypeMan == '' || this.data.idTypeMan <= 0 || this.data.idTypeWoman == '' || this.data.idTypeWoman <= 0) return;
          let param = {
            opType: this.data.opType,
            type: this.data.swFlag,
            manType: this.data.idTypeMan,
            womanType: this.data.idTypeWoman
          };
          this.$https.post("api/marriage/getAttachEnumerationType.do", param, response => {
            if (response.status === 200 && response.data.code === 200) {
              this.data.photoTypes = response.data.data;
            }
          })
        }
      },
      getVerifyCode(){
        this.$https.post("api/marriage/getValidCode.do", {},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.vImg=response.data.data.value
          }
        })
      },
      onSelectedRegion(v){
        if(this.checkCity && this.checkCity.length>2){
          this.data.regSjMan=v[0]
          this.data.regDsMan=v[1]
          this.data.regQxMan=v[2]
          this.checkCity=v[2]
        }else{}
      },
      onSelectedRegion2(v){
        if(this.checkCity2 && this.checkCity2.length>2){
          this.data.regSjWoman=v[0]
          this.data.regDsWoman=v[1]
          this.data.regQxWoman=v[2]
          this.checkCity2=v[2]
        }else{}
      },

      // 校验异地标识
      checkAllowYd() {
        if(this.data.swFlag == 1 && this.data.idTypeMan != 1 && this.data.idTypeWoman != 1) {
          this.$message.error('男女双方必须有一方是内地居民');
          return false;
        }
        if(this.deptCode.length < 6) {
          this.$message.error('登记机构区划码错误');
          return false;
        }
        if(this.data.swFlag==0){
        if(this.allowYd == 0) {
          // 区内
          if((this.data.regQxMan.length >= 6 && this.deptCode.substring(0, 6) == this.data.regQxMan.substring(0, 6))
            || (this.data.regQxWoman.length >= 6 && this.deptCode.substring(0, 6) == this.data.regQxWoman.substring(0, 6))) return true;
          this.$message.error('该机构只能办理区县内业务，男女双方必须有一人长住户口在该机构所属区县内');
        } else if(this.allowYd == 1) {
          // 市内
          if((this.data.regQxMan.length >= 6 && this.deptCode.substring(0, 4) == this.data.regQxMan.substring(0, 4))
            || (this.data.regQxWoman.length >= 6 && this.deptCode.substring(0, 4) == this.data.regQxWoman.substring(0, 4))) return true;
          this.$message.error('该机构只能办理市内业务，男女双方必须有一人长住户口在该机构所属市内');
        } else if (this.allowYd == 2) {
          // 省内
          if((this.data.regQxMan.length >= 6 && this.deptCode.substring(0, 2) == this.data.regQxMan.substring(0, 2))
            || (this.data.regQxWoman.length >= 6 && this.deptCode.substring(0, 2) == this.data.regQxWoman.substring(0, 2))) return true;
          this.$message.error('该机构只能办理省内业务，男女双方必须有一人长住户口在该机构所属省内');
        } else if(this.allowYd == 3) {
          // 省外
          return true;
        }
        }else{
          if(this.deptCode.substring(0, 2) != this.data.regQxMan.substring(0, 2) && this.deptCode.substring(0, 2) != this.data.regQxWoman.substring(0, 2)){
              this.$message.error('预约男女双方，必须有一人为青海省内户口');
              return false;
          }else{
              return true;
          }
        }
        return false;
      },
      submit(){
        this.$refs['ruleForm'].validate((valid) => {
          if (this.data.regSjMan!="630000"&&this.data.regSjWoman!="630000"){
            this.data.sfys=1;
          }
          if(!this.checkAllowYd()) return;
          if (valid) {
            var loading = this.$loading({
              lock: true,
              text: '数据提交中,请耐心等待....',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            /*//组装男方、女方生日
            let uidInfo=this.$util.uid.parse_person_uid(this.data.certNumMan);
            this.data.birthMan=uidInfo.birthday;
            let uidInfowm=this.$util.uid.parse_person_uid(this.data.certNumWoman);
            this.data.birthWoman=uidInfowm.birthday;*/
            const options={
              data:this.data,
              attach:this.data.photoTypes,
            }
            this.$https.post("api/marriage/saveMarryQh.do", options, response => {
              if (response.status === 200 && response.data.code === 200) {
                loading.close();
                // this.$alert('预约成功！', {
                //   confirmButtonText: '确定'}).then(() => {
                //   this.$router.push('personal_cardMaking');
                // });
                  this.$alert('您可以在个人中心-》我的预约中查看预约详细！', '预约成功', {
                      confirmButtonText: '确定',
                      callback: action => {
                          this.getMarriageSuccInfo(response.data.data.id,response.data.data.marrayId);
                          this.$router.push('personal_cardMaking');
                      }});
              }else {
                loading.close();
                this.$alert(response.data.msg, {
                  confirmButtonText: '确定'});
                this.getVerifyCode();
              }
            })
          }else {
            return
          }
        })
      },
      getMarriageSuccInfo(id,marryId){
        this.$https.post("api/marriage/getSuccessInfo.do",{"id":id,"marryId":marryId},response=>{

        })
      },
      handleDialogClose(){
        this.urlTo('marriageAppointment',{opType:this.data.opType,title:this.title,swFlag: this.data.swFlag});
      },
      clauseClose(){
        this.showClause=false;
      },
      checkDepartId(rule,value,callback){
        if(!this.checkCity || this.checkCity.length<=0){
          return callback(new Error('请选择常住户口'))
        }
        return callback()
      },
      checkDepartId2(rule,value,callback){
        if(!this.checkCity2 || this.checkCity2.length<=0){
          return callback(new Error('请选择常住户口'))
        }
        return callback()
      },

      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },
    }
  }



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/marriage/MarriageAppointmentSubmit.vue